//import logo from './logo.svg';
import './App.css';
import MemberTable from './MemberTable';
import Member from './Member';
import React from "react";
import loading from './loading.gif';
let baseurl = "http://localhost:3000";
class App extends React.Component {
  constructor(props){
    console.log("b")
    super(props);
    this.handleLoad = this.handleLoad.bind(this);
    let queryObj;
    //let info = Character.find(queryObj.query,{});
    let info;
    this.state={rows:info};
  }
  async handleLoad(){
    let info =// {"_id":{"$oid":"5ed199ea2446cc0042b96958"},"awk_ap":{"$numberInt":"311"},"ap":{"$numberInt":"309"},"character_name":"woolad","class_name":"Wizard","discord_id":"169562372430757889","dp":{"$numberInt":"412"},"family_name":"yellowman","gear_score":{"$numberInt":"723"},"level":{"$numberInt":"61"},"updated_at":{"$date":{"$numberLong":"1672109029350"}},"image_url":"https://i.imgur.com/qdxAgLb.png"}
     await fetch(baseurl+"/info/members/",{method:"POST",headers:{ "Content-Type": "application/json","Accept":"application/json"},body:JSON.stringify({})}).catch(error => {
      window.alert(error);
      console.log(error)
      return;
    });
    //window.alert("asdf");
    this.setState({rows:info});
  }
  render(){
  let ra = this.state.rows;
  const rowArray = [];
  //window.alert("dash2");
  //this.handleLoad();
  for(var i in ra){
      rowArray.push(<Member info={ra[i]} />)
  }
  return (
    
    <div className="App"><button onClick={this.handleLoad}>click</button>
      <header className="App-header">
      </header>
        <img src={loading} alt="" />
        <MemberTable rowArray={rowArray} />
    </div>
  );
  }
};

export default App;
 